export const faqs = [
  {
    q: 'What is the DPDPA?',
    a: "The Digital Personal Data Protection Act, 2023 is India's first comprehensive data protection law. It governs how organisations (\"Data Fiduciaries\") collect, process and protect the digital personal data of individuals (\"Data Principals\"), and is operationalised by the DPDP Rules, 2025.",
  },
  {
    q: 'What are the DPDP Rules, 2025?',
    a: 'The DPDP Rules, 2025, notified by MeitY on 13 November 2025, are the subordinate legislation that operationalises the Act. Their 23 rules and 7 schedules prescribe notice formats, Consent Manager registration, minimum security safeguards, the 72-hour breach reporting process, erasure timelines, verifiable parental consent for children, SDF duties and cross-border transfers.',
  },
  {
    q: 'When is the DPDPA compliance deadline?',
    a: 'The DPDP Rules were notified in November 2025 with a phased rollout: the Data Protection Board is already operational, Consent Manager registration opens by November 2026, and full compliance with the substantive obligations is required by 13 May 2027.',
  },
  {
    q: 'Who does the DPDPA apply to?',
    a: "It applies to the processing of digital personal data within India, and to processing outside India where it relates to offering goods or services to individuals in India — a territorial reach comparable to the GDPR's.",
  },
  {
    q: 'What are the maximum penalties under the DPDPA?',
    a: 'Up to ₹250 crore for failure of reasonable security safeguards, ₹200 crore for failure to notify a breach or for children\'s-data violations, ₹150 crore for Significant Data Fiduciary breaches, and ₹50 crore for other violations — per instance.',
  },
  {
    q: 'What constitutes valid consent under Section 6?',
    a: 'Consent must be free, specific, informed, unconditional and unambiguous, given through a clear affirmative action, and limited to data necessary for the stated purpose. It must be as easy to withdraw as it was to give.',
  },
  {
    q: 'How do I handle a Data Principal rights request?',
    a: 'Authenticate the requester, locate their data across every system it lives in, and respond within the timelines prescribed by Rule 14 — covering access (Section 11), correction and erasure (Section 12), and grievance redressal (Section 13).',
  },
  {
    q: 'What tools help with DPDPA compliance?',
    a: 'Privacy operations platforms automate the recurring work the Act creates: data discovery, consent lifecycle, rights requests, DPIAs, breach workflows and audit evidence. ZenDPO is a privacy-ops platform built specifically for the DPDPA.',
  },
  {
    q: 'How do I train as a DPDPA consultant or DPO?',
    a: 'Choose practitioner-led training covering the Act, the Rules, DPIA methodology and consent architecture with hands-on tooling. A dedicated DPDPA Academy runs a consultant training programme built for exactly this.',
  },
];
